var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlackThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#E4E4E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69482 10.1107C3.69482 11.0358 2.93912 11.7915 2.01403 11.7915C1.08895 11.7915 0.333252 11.0358 0.333252 10.1107C0.333252 9.18563 1.08895 8.42993 2.01403 8.42993H3.69482V10.1107Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54175 10.1107C4.54175 9.18563 5.29745 8.42993 6.22253 8.42993C7.14761 8.42993 7.90331 9.18563 7.90331 10.1107V14.3192C7.90331 15.2443 7.14761 16 6.22253 16C5.29745 16 4.54175 15.2443 4.54175 14.3192V10.1107Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22253 3.36156C5.29745 3.36156 4.54175 2.60586 4.54175 1.68078C4.54175 0.755701 5.29745 0 6.22253 0C7.14761 0 7.90331 0.755701 7.90331 1.68078V3.36156H6.22253Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2225 4.2085C7.14758 4.2085 7.90328 4.9642 7.90328 5.88928C7.90328 6.81436 7.14758 7.57006 6.2225 7.57006H2.01403C1.08895 7.57006 0.333252 6.81436 0.333252 5.88928C0.333252 4.9642 1.08895 4.2085 2.01403 4.2085H6.2225Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9717 5.88928C12.9717 4.9642 13.7274 4.2085 14.6525 4.2085C15.5775 4.2085 16.3332 4.9642 16.3332 5.88928C16.3332 6.81436 15.5775 7.57006 14.6525 7.57006H12.9717V5.88928Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1247 5.88925C12.1247 6.81433 11.369 7.57003 10.444 7.57003C9.51888 7.57003 8.76318 6.81433 8.76318 5.88925V1.68078C8.76318 0.755701 9.51888 0 10.444 0C11.369 0 12.1247 0.755701 12.1247 1.68078V5.88925Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.444 12.6384C11.369 12.6384 12.1247 13.3941 12.1247 14.3192C12.1247 15.2443 11.369 16 10.444 16C9.51888 16 8.76318 15.2443 8.76318 14.3192V12.6384H10.444Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.444 11.7915C9.51888 11.7915 8.76318 11.0358 8.76318 10.1107C8.76318 9.18563 9.51888 8.42993 10.444 8.42993H14.6524C15.5775 8.42993 16.3332 9.18563 16.3332 10.1107C16.3332 11.0358 15.5775 11.7915 14.6524 11.7915H10.444Z",
    fill: "#ECB22E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackThumb);
export default __webpack_public_path__ + "static/media/slack_thumb.005b9c1e58ea2be4be1d37ef9af57410.svg";
export { ForwardRef as ReactComponent };